import { render, staticRenderFns } from "./publicManage.vue?vue&type=template&id=bb005280&scoped=true&"
import script from "./publicManage.vue?vue&type=script&lang=js&"
export * from "./publicManage.vue?vue&type=script&lang=js&"
import style0 from "./publicManage.vue?vue&type=style&index=0&id=bb005280&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb005280",
  null
  
)

export default component.exports